var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-1 -3 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50002 9.00013H4.88199C5.56719 9.00013 6.19359 9.38727 6.50002 10.0001C6.80645 10.613 7.43285 11.0001 8.11806 11.0001H13.882C14.5672 11.0001 15.1936 10.613 15.5 10.0001C15.8065 9.38727 16.4329 9.00013 17.1181 9.00013H20.5M7.96658 1.00013H14.0335C15.1103 1.00013 15.6488 1.00013 16.1241 1.1641C16.5445 1.30909 16.9274 1.54573 17.2451 1.85688C17.6043 2.20873 17.8451 2.69033 18.3267 3.65351L20.4933 7.98663C20.6823 8.36462 20.7768 8.55361 20.8434 8.75168C20.9026 8.92758 20.9453 9.1086 20.971 9.2924C21 9.49936 21 9.71066 21 10.1333V12.2001C21 13.8803 21 14.7204 20.673 15.3621C20.3854 15.9266 19.9265 16.3855 19.362 16.6732C18.7203 17.0001 17.8802 17.0001 16.2 17.0001H5.80002C4.11986 17.0001 3.27978 17.0001 2.63805 16.6732C2.07356 16.3855 1.61462 15.9266 1.327 15.3621C1.00002 14.7204 1.00002 13.8803 1.00002 12.2001V10.1333C1.00002 9.71066 1.00002 9.49936 1.029 9.2924C1.05473 9.1086 1.09746 8.92758 1.15664 8.75168C1.22328 8.55361 1.31778 8.36462 1.50677 7.98663L3.67333 3.65351C4.15493 2.69033 4.39572 2.20873 4.75497 1.85688C5.07265 1.54573 5.45554 1.30909 5.87591 1.1641C6.35127 1.00013 6.88971 1.00013 7.96658 1.00013Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox01);
export default __webpack_public_path__ + "static/media/inbox-01.ef50d7a80c0b6fd6a90c7bffbfd22f71.svg";
export { ForwardRef as ReactComponent };